module.exports = __webpack_public_path__ + "img/cv.78ad982c.png";